
const appOptions = {
    appTheme: 'transparent',
    appDarkMode: false,
    appGradientEnabled: false,
    appSidebarMinified: false,
    appSidebarNone: false,
    appSidebarEnd: false,
    appSidebarTwo: false,
    appSidebarWide: false,
    appSidebarLight: false,
    appSidebarTransparent: false,
    appSidebarMobileToggled: false,
    appSidebarEndMobileToggled: false,
    appSidebarEndToggled: false,
    appSidebarEndCollapsed: false,
    appSidebarSearch: false,
    appSidebarFixed: true,
    appSidebarGrid: false,
    appContentFullHeight: false,
    appContentClass: false,
    appHeaderLanguageBar: false,
    appHeaderInverse: false,
    appHeaderMegaMenu: false,
    appHeaderFixed: true,
    appHeaderMegaMenuMobileToggled: false,
    appTopMenu: false,
    appTopMenuMobileToggled: false,
    appEmpty: false,
    appBodyScrollTop: 0,
}

export default appOptions;